import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  electronicForms: "ElectronicForm.ElectronicForms",
  list: "ElectronicForm.ElectronicFormList",
  /** Shared new-worksheet type picker: `/electronicForm/worksheet-new/:parentFormId` */
  worksheetNew: "ElectronicForm.WorksheetNew",
};

export { names as electronicFormRouteNames };

const electronicFormRoutes: RouterOptions["routes"] = [
  {
    path: "/electronicForm",
    name: names.electronicForms,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Electronic Forms" },
        component: () => import("@/views/electronicForm/ElectronicFormList.vue"),
      },
      {
        path: "worksheet-new/:parentFormId(\\d+)",
        name: names.worksheetNew,
        meta: { title: "New Worksheet", isNew: true },
        component: () => import("@/views/electronicForm/worksheets/WorksheetSelect.vue"),
      },
    ],
  },
];
export default electronicFormRoutes;
